export default {
    formatSecondsToPrettyTime(totalSeconds) {
        const sec_num = parseInt(totalSeconds, 10);

        const hours: number = Math.floor(sec_num / 3600);
        const minutes: number = Math.floor((sec_num - hours * 3600) / 60);
        const seconds: number = sec_num - hours * 3600 - minutes * 60;

        const hoursString = hours < 10 ? "0" + hours : hours.toString();
        const minutesString = minutes < 10 ? "0" + minutes : minutes.toString();
        const secondsString = seconds < 10 ? "0" + seconds : seconds.toString();

        return hoursString + ":" + minutesString + ":" + secondsString;
    },
    formatSecondsToMinutesAndSeconds(totalSeconds: number, format: "colon" | "compact" = "colon") {
        totalSeconds = Number(totalSeconds);
        if (totalSeconds < 0) {
            throw Error("Non natural number.");
        }

        if (totalSeconds === 0) {
            return format === "compact" ? "0m" : "00:00";
        }

        const sec_num = Number(totalSeconds);

        if (format === "compact") {
            const hours = Math.floor(sec_num / 3600);
            const minutes = Math.floor((sec_num % 3600) / 60);

            if (hours === 0) {
                return `${minutes}m`;
            }
            if (minutes === 0) {
                return `${hours}h`;
            }
            return `${hours}h${minutes}m`;
        }

        const minutes = Math.floor(totalSeconds / 60);
        const seconds = sec_num % 60;

        const minutesString = minutes < 10 ? "0" + minutes : minutes.toString();
        const secondsString = seconds < 10 ? "0" + seconds : seconds.toString();

        return minutesString + ":" + secondsString;
    },
    formatToSeconds(mmss) {
        let [minutes, seconds] = mmss.split(":");

        if (!seconds) {
            seconds = minutes;
            minutes = 0;
        }

        return parseInt(minutes, 10) * 60 + parseInt(seconds, 10);
    },
};
